module.exports = cacheable-lookup;